/* km-mega-pos — posiciona el mega-menú centrado bajo su trigger (Teléfonos) */
(function () {
  function init() {
    var h = document.querySelector('.header-area');
    var items = document.querySelectorAll('.km-mega-dropdown');
    if (!h || !items.length) return;
    function reposition() {
      var t = Math.round(h.getBoundingClientRect().bottom);
      items.forEach(function (d) {
        d.style.setProperty('top', t + 'px', 'important');
        var parent = d.closest('.km-mega-parent');
        var trig = parent ? parent.querySelector('.km-mega-trigger') : null;
        if (trig) {
          var rect = trig.getBoundingClientRect();
          var w = d.offsetWidth || 700;
          var left = rect.left + (rect.width / 2) - (w / 2);
          var maxLeft = window.innerWidth - w - 16;
          if (left > maxLeft) left = maxLeft;
          if (left < 16) left = 16;
          d.style.setProperty('left', Math.round(left) + 'px', 'important');
        }
      });
    }
    reposition();
    window.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('resize', reposition, { passive: true });
    document.querySelectorAll('.km-mega-parent').forEach(function (p) {
      p.addEventListener('mouseenter', reposition);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
